var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgView = function SvgView(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 14,
    viewBox: "0 0 24 14"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "view_svg__path-1",
    d: "M23.793 11.44C20.723 7.43 16.551 5 11.985 5S3.247 7.468.177 11.44a.97.97 0 0 0 0 1.12C3.247 16.57 7.42 19 11.985 19s8.738-2.468 11.808-6.44c.276-.348.276-.81 0-1.12m-6.77.85c-.157 2.468-2.204 4.473-4.723 4.627-3.03.193-5.55-2.275-5.353-5.245.158-2.468 2.204-4.474 4.723-4.628 3.031-.193 5.55 2.276 5.353 5.245m-2.322-.155c-.079 1.311-1.18 2.391-2.519 2.468-1.653.116-2.991-1.234-2.873-2.815.078-1.311 1.18-2.391 2.519-2.468 1.614-.116 2.991 1.234 2.873 2.815"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view_svg__Guidelines",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "view_svg__icons-badges-variations",
    transform: "translate(-295 -242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "view_svg__icons/view",
    transform: "translate(295 237)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "view_svg__mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#view_svg__path-1"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#view_svg__path-1",
    id: "view_svg__Shape",
    fill: "#1A1A1A",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "view_svg__color/black-tint/0-000000",
    fill: "#000",
    fillRule: "evenodd",
    mask: "url(#view_svg__mask-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "view_svg__gray-70-4A4A4A",
    d: "M0 0h24v24H0z"
  })))))));
};
export default SvgView;